
// import NewsListing from './NewsListing'
import CarousalTabViewNews from './CarousalTabViewNews';
import GridCardNews from './GridCardNews';
import SideImagesNews from './SideImagesNews';
import StackedOverlayNews from './StackedOverlayNews';
import BlogsGridNews from './BlogsGridNews';
import { useSelector } from 'react-redux';

function NewsUpdatesWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>


      {sitedata?.theme_latest_news === "carousel" ? (
        <CarousalTabViewNews />
      ) : sitedata?.theme_latest_news === "grid-card" ? (
        <GridCardNews />
      ) : sitedata?.theme_latest_news === "side-image" ? (
        <SideImagesNews />
      ) : sitedata?.theme_latest_news === "stacked-overlay" ? (
        <StackedOverlayNews />
      ) : (
        <BlogsGridNews />

      )}


      {/* <NewsListing/> */}
    </>
  )
}

export default NewsUpdatesWrapper;